import { Switch, Group, Text, Box } from "@mantine/core";
import { useEffect } from "react";
import _ from "lodash";
import { IconCircleCheck, IconAlertCircle } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import { SFC_LICENCE_TYPES, DEFAULT_SFC_LICENCES } from "../data/sfcLicences";

const SfcLicenceCheckList = ({
  form,
  name,
  label,
  readOnly = false,
  ...props
}) => {
  const { t } = useTranslation();
  const allLicences = SFC_LICENCE_TYPES.map(({ name, labelKey }) => ({
    name,
    label: t(labelKey),
  }));

  useEffect(() => {
    if (!_.get(form.values, name)) {
      form.setFieldValue(name, { ...DEFAULT_SFC_LICENCES });
    }
  }, [form, name]);

  const licences = {
    ...DEFAULT_SFC_LICENCES,
    ...(_.get(form.values, name) || {}),
  };

  return (
    <>
      {allLicences.map((lic) => (
        <Box key={lic.name} mb="sm">
          {!readOnly && (
            <Switch
              key={`sfcLicences.${lic.name}`}
              label={lic.label}
              value={licences[lic.name]}
              checked={licences[lic.name]}
              disabled={readOnly}
              {...form.getInputProps(`${name}.${lic.name}`)}
            />
          )}
          {readOnly && (
            <Group spacing="sm" noWrap align="flex-start">
              {licences[lic?.name] ? (
                <IconCircleCheck color="#00b341" size={18} style={{ flexShrink: 0 }} />
              ) : (
                <IconAlertCircle color="#ff4500" size={18} style={{ flexShrink: 0 }} />
              )}
              <Text size="sm">{lic.label}</Text>
            </Group>
          )}
        </Box>
      ))}
    </>
  );
};

export default SfcLicenceCheckList;
